import AppDataService from "./AppDataService";

const COMMON_BASE = 'BOI'

export default class BoiDataService {
    
    static async getBoiForms(params){
        return await AppDataService.get(`${COMMON_BASE}/GetBOIGrid`, {params});
    }
    static async getFormData(params){
        return await AppDataService.get(`${COMMON_BASE}/GetForm`, {params});
    }

    static async getBoiFormFields(formName, formRecordId){
        let url = ``;
        if(formRecordId){
            url = `&formRecordId=${formRecordId}`
        }
        return await AppDataService.get(`${COMMON_BASE}/GetFormFields?formName=${formName}${url}`);
    }

    static async onDependentFieldChangeGetValues(onDependentFieldChangeData) {
        return await AppDataService.post(`${COMMON_BASE}/CalculateInferredValues`, onDependentFieldChangeData);
    }

    static async saveBoiForm(formData) {
        return await AppDataService.post(`${COMMON_BASE}/Save`, formData);
    }

    static async saveCompanyApplicants(formData) {
        return await AppDataService.post(`${COMMON_BASE}/SaveApplicant`, formData);
    }
    
    static async saveReportingCompany(formData) {
        return await AppDataService.post(`${COMMON_BASE}/SaveReportingCompany`, formData);
    }

    static async getReportingCompanyDetails(params){
        return await AppDataService.get(`${COMMON_BASE}/GetReportingCompanyDetails`, {params});
    }

    static async viewPDF(FormRecordId) {
        return await AppDataService.get(`${COMMON_BASE}/GetBOIPDF?FormRecordId=${FormRecordId}`)
    }

    static async BoiPayment(data) {
        return await AppDataService.post(`${COMMON_BASE}/BOIPayment`, data)
    }


    static async getBeneficiaryOwners(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetBeneficiaryOwners`, { params });
    }

    static async getBeneficiaryOwnerDetails(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetBoiDetails`, { params });
    }

    static async submitBenefiaryOwner(data) {
        return await AppDataService.post(`${COMMON_BASE}/SaveBoi`, data)
    }

    static async requestBeneficiaryOwnerEmail(params) {
        return await AppDataService.get(`${COMMON_BASE}/RequestBoi`, { params });
    }

    static async deleteBoiForm(data) {
        return await AppDataService.delete(`${COMMON_BASE}/Delete`, data)
    }

    static async deleteBeneficiary(data) {
        return await AppDataService.delete(`${COMMON_BASE}/DeleteBoi`, data)
    }

    static async deleteReportingCompany(data) {
        return await AppDataService.delete(`${COMMON_BASE}/DeleteReportingCompany`, data)
    }

    static async boiLifeTimePayment(data) {
        return await AppDataService.post(`${COMMON_BASE}/BOILifeTimePayment`, data)
    }
    
    static async getCompanyApplicants(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetApplicantsbyPayer`, { params });
    }
    
    static async getReviewData(data) {
        return await AppDataService.post(`${COMMON_BASE}/GetBoiReviewDetails`, data)
    }

    static async resubmitBoi(data) {
        return await AppDataService.put(`${COMMON_BASE}/ResubmitBoi`, data);
    }
}